<template>
    <div class="table-wrapper" style="padding-top: 30px">
        <div class="fchart-wrapper" style="margin-bottom: 24px;">
            <div class="aFlex fchart-top">
                <span class="ft-bold">请选择统计时间：</span>
                <DatePicker style="width: 180px;" type="month" placement="bottom-end" transfer placeholder="请选择" :value="dateMonth" @on-change="onDateMonth" ></DatePicker>
                <Select style="width: 160px; margin-left: 16px" v-model="areaCode" @on-change='changeLine1' placeholder="选择地区" clearable>
                    <Option v-for="item in area" :value="item.value" :key="item.value" >{{ item.label }}</Option>
                </Select>
            </div>
            <Row :gutter="24">
                <Col span="12">
                    <div class="fchart-box" style="margin-bottom: 0">
                        <salaryBarLine ref="salaryBarLine" :areaCode="areaCode" :dateMonth="dateMonth"></salaryBarLine>
                    </div>
                </Col>
                <Col span="12">
                    <div class="fchart-box" style="margin-bottom: 0">
                        <payProject ref="payProject" :areaCode="areaCode" :dateMonth="dateMonth"></payProject>
                    </div>
                </Col>
            </Row>
        </div>
        <div class="fchart-box">
            <salaryBarT></salaryBarT>
        </div>
        <div class="fchart-box">
            <salaryBar></salaryBar>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import payProject from './components/payProject';
    import salaryBarLine from './components/salaryBarLine';
    import salaryBar from './components/salaryBar';
    import salaryBarT from './components/salaryBarT';
    export default {
        data(){
            return {
                areaCode: localStorage.getItem('tenantAreaCode'),
                dateMonth:'',
                dateYear:'',
            };
        },
        components:{
            salaryBarLine,
            payProject,
            salaryBar,
            salaryBarT,
        },
        computed: {
            ...mapState(['area']),
        },
        watch: {

        },
        created(){
        },
        mounted(){

        },
        methods: {
            // 第一行 <
            // 地区改变
            changeLine1(e) {
                this.areaCode = e || localStorage.getItem('tenantAreaCode');
                this.$nextTick(() => {
                    this.$refs.salaryBarLine.getData();
                    this.$refs.payProject.getData();
                })
            },
            // 月份改变
            onDateMonth(e){
                this.dateMonth=e;
                this.$nextTick(() => {
                    this.$refs.salaryBarLine.getData();
                    this.$refs.payProject.getData();
                })
            },
        }
    };
</script>
